import React, { useState, useEffect } from 'react';
import ReactDOMServer from 'react-dom/server';
import { INROUTES, EXTERNAL_LINKS } from './../../common/links';

import IcClose from './../../assets/icon/ic-close.svg';
import IcArrow from './../../assets/icon/ic-arrow-min.svg';

const faqList = [
  {
    subject: "Wi-Fi 리스트에 SKYTONE이 안 보여요.",
    context:[
      {t:"아래 몇 가지 방법으로 다시 시도해 보세요."},
      {t:""},
      {t:"1_ SKYTONE 전원을 껐다 켠 후, 빨간색 LED가 깜빡일 때까지 기다린 후, Wi-Fi 목록을 재확인합니다."},
      {t:"2_ 1번 진행 후에도 목록이 보이지 않으면, 현재 이용중인 Wi-Fi의 자동으로 다시 연결 옵션을 끈 후 다시 시도해보세요."},
      {t:"3_ SKYTONE Wi-Fi 첫 연결 시 네트워크 보안 경고가 보이면, 확인을 눌러 연결을 활성화 해주세요."},
      {t:""}
    ],
    contact:{
      textBefore:"위 과정을 3~4회 반복 시도 후에도 계속 같은 문제가 발생하면",
      buttonText:"[문의하기]",
      link:EXTERNAL_LINKS.KAKAOCH,
      textAfter:"를 통해 연락주시기 바랍니다."
    }
  }, {
    subject: "지역을 바꾸고 싶어요.",
    context:[
      {t:"인터넷 브라우저를 열어 주소창에 고유 IP를 입력하면 설정 페이지에 접속할 수 있습니다."},
      {t:"이 곳에서 지역을 바꿀 수 있어요."},
      {t:""},
      {tag:"small", t:"* SKYTONE과 동일한 네트워크 환경에서 시도해야 합니다."}
    ],
    contact:{
      tag:"small",
      textBefore:"* 고유 IP를 잊으셨다면, ",
      buttonText:"[여기]",
      link:INROUTES.FINDMYDEVICE,
      textAfter:"에서 자세한 내용을 확인해보세요."
    }
  }, {
    subject: "설정 페이지 주소(고유 IP)를 잊어버렸어요.",
    context:[
      {t:"고유 IP는 별도로 기록하거나 북마크에 저장해 두시면 더 편리하게 이용하실 수 있습니다."}
    ],
    contact:{
      textBefore:"미처 기록하지 못해 잊었다면,",
      buttonText:"[여기]",
      link:INROUTES.FINDMYDEVICE,
      textAfter:"에서 자세한 내용을 확인해보세요."
    }
  }, {
    subject: "색상이 안 바뀌고 매일 똑같아요.",
    context:[
      {t:"SKYTONE은 한국환경공단에서 발표하는 지역별 대기오염 지수를 실시간 수집하고,"},
      {t:"특정한 알고리즘에 따라 색으로 표현하고 있습니다."},
      {t:""},
      {t:"대기상태가 일정하게 유지되고 있어 색 변화가 없는 것이니 안심해도 좋아요!"}
    ]
  }, {
    subject: "USB를 꽂아도 전원이 켜지지 않아요.",
    context:[
      {t:"SKYTONE은 매우 적은 전력을 사용합니다."},
      {t:"전력 소모량이 미세하다보니 전원 장치(USB 충전기, 보조 배터리) 중 일부 기종의 경우,"},
      {t:"누전으로 오인하여 출력 자체를 막는 경우가 있습니다."},
      {t:""},
      {t:"컴퓨터 USB에 연결해 작동 여부를 체크해주세요."},
      {t:"- 정상 작동한다면, 기기 이상이 아니므로 다른 전원장치를 이용해 주세요."}
    ],
    contact:{
      textBefore:"- 작동되지 않는다면,",
      buttonText:"[문의하기]",
      link:EXTERNAL_LINKS.KAKAOCH,
      textAfter:"를 통해 연락주시기 바랍니다."
    }
  }, {
    subject: "SKYTONE 여러 개를 한번에 사용하고 싶어요.",
    context:[
      {t:"같은 네트워크 상에 있더라도 기기별로 고유 IP가 새로 생성되므로, 여러 대의 SKYTONE을 사용할 수 있습니다."},
      {t:"관리 상에 혼선이 없도록, 기기 뒷면에 각각의 고유 IP를 따로 기록해 두시기를 권장합니다."}
    ]
  }, {
    subject: "청록색 화면이 계속 깜빡거려요.",
    context:[
      {t:"기기의 청록색 불빛이 깜빡이는 것은 네트워크를 찾고 있다는 신호입니다."},
      {t:"점멸이 멈출 때까지 잠시 기다려 주세요."}
    ]
  }, {
    subject: "핑크색 화면이 계속 깜빡거려요.",
    context:[
      {t:"기기의 핑크색 불빛이 깜빡이는 것은 저장된 네트워크가 없거나 기존 저장된 네트워크에 연결 할 수 없다는 신호 입니다."},
      {t:""},
      {t:"네트워크 환경이 바뀌거나, 새로 세팅하는 기기인 경우"}
    ],
    contact:{
      buttonText:"[Wi-Fi 설정]",
      link:INROUTES.SKYTONE_WIFI,
      textAfter:" 페이지를 참고하여 새 네트워크를 연결해 주세요. "
    }
  }, {
    subject: "잘 사용중이던 기기가 화면이 계속 깜빡거려요.",
    context:[
      {t:"기기의 불빛이 깜빡이는 것은 네트워크를 찾고 있다는 신호입니다. 만약 정상적으로 사용 중인 기기가 계속 깜빡거린다면, 아래의 원인과 해결 방법을 참고하세요."},
      {t:""},
      {t:"1. 네트워크 신호 불안정"},
      {t:"- 네트워크 신호가 불안정하여 연결이 끊길 수 있습니다. 이 경우, 공유기 가까이에서 기기를 사용해 주세요."},
      {t:""},
      {t:"2. 멀티 USB 충전기 사용"},
      {t:"- 일부 멀티 USB 충전기는 다른 포트를 사용할 때 전원을 잠시 끊었다가 다시 연결하는 경우가 있습니다. 이로 인해 SKYTONE의 전원이 반복적으로 끊어졌다 연결 되면서 화면이 깜빡일 수 있습니다."}
    ]
  }, {
    subject: "사용하던 공유기 접속 정보가 바뀌었어요.",
    context:[],
    contact:{
      buttonText:"[Wi-Fi 설정]",
      link:INROUTES.SKYTONE_WIFI,
      textAfter:" 페이지를 참고하여 새 네트워크를 연결해 주세요. "
    }
  }, {
    subject: "부품을 잃어버렸어요.",
    context:[
      {t:"분실한 부품의 종류 및 갯수를 확인 후"}
    ],
    contact:{
      buttonText:"[문의하기]",
      link:EXTERNAL_LINKS.KAKAOCH,
      textAfter:"를 통해 연락주시기 바랍니다."
    }
  }, {
    subject: "거주지가 아닌 다른 지역으로 설정하려고 해요.",
    context:[
      {t:"인터넷 브라우저를 열어 주소창에 고유 IP를 입력하면 설정 페이지에 접속할 수 있습니다."},
      {t:"국내 어디든 원하는 지역으로 설정하여 사용하실 수 있어요!"},
      {t:""},
      {tag:"small", t:"* SKYTONE과 동일한 네트워크 환경에서 시도해야 합니다."}
    ],
    contact:{
      tag:"small",
      textBefore:"* 고유 IP를 잊으셨다면, ",
      buttonText:"[여기]",
      link:INROUTES.FINDMYDEVICE,
      textAfter:"에서 자세한 내용을 확인해보세요."
    }
  }, {
    subject: "하늘색이 알록달록해요.",
    context:[
      {t:"모듈에 포함된 LED는 왼쪽부터 각각 통합대기환경지수, 미세먼지, 초미세먼지 수치를 나타내는데"},
      {t:"빛이 푸른색에 가까울 수록 좋은 상태이며, 오염도에 따라 점점 붉은색에 가깝게 변합니다."},
      {t:"특정 지표만 유독 나쁘거나 좋다면 여러 가지 색이 섞이며 특별한 하늘색이 되곤 해요."}
    ]
  }, {
    subject: "해외에서도 사용 가능한가요?",
    context:[
      {t:"한국의 대기오염 데이터를 기반으로 작동하며,"},
      {t:"따라서 지역도 국내로만 설정할 수 있습니다."},
      {t:"외국에서도 한국의 공기질을 확인해야만 하는 특별한 경우가 아니라면, 사용을 추천드리지 않아요."}
    ]
  }, {
    subject: "전면 필름을 바꾸고 싶어요.",
    context:[
      {t:"SKYTONE은 DIY 제품으로 액자의 사진을 바꾸듯, 언제든 취향에 따라 필름을 교체할 수 있습니다."},
      {t:""}
    ],
    contact:{
      buttonText:"[스마트스토어]",
      link:EXTERNAL_LINKS.BUYSKYTONE,
      textAfter:"에서 다양한 디자인의 필름을 판매하고 있으니 구경해 보세요."
    },
    afterContext:[
      {tag:"small",t:"- 직접 디자인한 파일을 출력해 보거나, 그림을 그려도 좋아요. 스티커를 사용해 다꾸하듯 꾸며보는 것도 재미있을 거예요!"}
    ]
  }, {
    subject: "조명이 너무 밝거나 어두워요.",
    context:[
      {t:"인터넷 브라우저를 열어 주소창에 고유 IP를 입력하면 설정 페이지에 접속할 수 있습니다."},
      {t:"이 곳에서 밝기 조절이 가능하고, 야간 모드(NIGHT MODE)를 활성화시켜 특정 시간대에만 어둡게 설정할 수도 있어요!"},
      {t:""},
      {tag:"small", t:"* SKYTONE과 동일한 네트워크 환경에서 시도해야 합니다."}
    ],
    contact:{
      tag:"small",
      textBefore:"* 고유 IP를 잊으셨다면, ",
      buttonText:"[여기]",
      link:INROUTES.FINDMYDEVICE,
      textAfter:"에서 자세한 내용을 확인해보세요."
    }
  }, {
    subject: "잘 때만 어둡게 하고 싶어요.",
    context:[
      {t:"인터넷 브라우저를 열어 주소창에 고유 IP를 입력하면 설정 페이지에 접속할 수 있습니다."},
      {t:"이 곳에서 밝기 조절이 가능하고, 야간 모드(NIGHT MODE)를 활성화시켜 특정 시간대에만 어둡게 설정할 수도 있어요!"},
      {t:""},
      {tag:"small", t:"* SKYTONE과 동일한 네트워크 환경에서 시도해야 합니다."}
    ],
    contact:{
      tag:"small",
      textBefore:"* 고유 IP를 잊으셨다면, ",
      buttonText:"[여기]",
      link:INROUTES.FINDMYDEVICE,
      textAfter:"에서 자세한 내용을 확인해보세요."
    }
  }
]

const highlightText = (text, keyword) => {
  if (typeof text !== 'string') {
    return ''; // 문자열이 아닐 경우 빈 문자열 반환
  }
  if (!keyword) {
    return text; 
  }

  const regex = new RegExp(`(${keyword})`, 'gi');
  const parts = text.split(regex).map(part =>
    regex.test(part) ? `<i class="highlight">${part}</i>` : part
  );

  return parts.join('');
};

const extractTextFromChildren = (children, keyword) => {
  let elements = [];

  React.Children.forEach(children, (child) => {
    if (typeof child === 'string') {
      const keywordRegex = new RegExp(`(${keyword})`, 'gi');
      // 문자열에서 검색어를 찾아 하이라이트 추가
      const parts = child.split(keywordRegex).map((part, index) =>
        part.toLowerCase() === keyword.toLowerCase()
          ? <i key={index} className="highlight">{part}</i>
          : part
      );
      elements.push(...parts);
    } else if (typeof child === 'object' && child !== null) {
      const newChild = React.cloneElement(child, {
        children: extractTextFromChildren(child.props.children, keyword),
      });
      elements.push(newChild);
    }
  });

  return elements;
};

const AccordionItem = ({ keyword, item }) => {
  const makeContent = (item) => {
    return (
      <>
        {item.context
          ? item.context.map((content, index) =>
              content.tag ? (
                <content.tag key={index}>
                  {content.t}
                  <span className={`line-break ${!content.t ? 'empty' : ''}`}></span>      
                </content.tag>
              ) : (
                <React.Fragment key={index}>
                  {content.t}
                  <span className={`line-break ${!content.t ? 'empty' : ''}`}></span>   
                </React.Fragment>
              )
            )
          : null}
        {item.contact ? (
          item.contact.tag ? (
            <item.contact.tag>
              {item.contact.textBefore ? item.contact.textBefore : null}{' '}
              <a
                href={item.contact.link}
                target="_blank"
                rel="noreferrer noopener"
              >
                {item.contact.buttonText}
              </a>
              {item.contact.textAfter ? item.contact.textAfter : null}
            </item.contact.tag>
          ) : (
            <>
              {item.contact.textBefore ? item.contact.textBefore : null}{' '}
              <a
                href={item.contact.link}
                target="_blank"
                rel="noreferrer noopener"
              >
                {item.contact.buttonText}
              </a>
              {item.contact.textAfter ? item.contact.textAfter : null}
            </>
          )
        ) : null}
        {item.afterContext
          ? item.afterContext.map((content, index) =>
              content.tag ? (
                <content.tag key={index}>
                  <span className={`line-break ${!content.t ? 'empty' : ''}`}></span>     
                  {content.t}
                </content.tag>
              ) : (
                <React.Fragment key={index}>
                  <span className={`line-break ${!content.t ? 'empty' : ''}`}></span>     
                  {content.t}
                </React.Fragment>
              )
            )
          : null}
      </>
    );
  };

  const subject = item.subject;
  const content = makeContent(item);
  const contentText = extractTextFromChildren(content, keyword); // 이 부분은 그대로 유지
  const [isOpen, setIsOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [highlightedSubject, setHighlightedSubject] = useState(highlightText(subject, keyword));
  const [highlightedContent, setHighlightedContent] = useState(ReactDOMServer.renderToStaticMarkup(contentText));

  const changeIsOpen = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    setHighlightedSubject(highlightText(subject, keyword));
    setHighlightedContent(ReactDOMServer.renderToStaticMarkup(contentText));

    if(keyword){
      if (highlightedSubject.includes('<i') || highlightedContent.includes('<i')) {
        setIsOpen(true);
        setIsHidden(false);
      } else {
        setIsOpen(false);
        setIsHidden(true);
      }
    } else {
      setIsOpen(false);
      setIsHidden(false);
    }
  }, [keyword, highlightedSubject, highlightedContent]);

  return (
    <div className={`accordion-item ${isOpen ? 'opened' : ''} ${isHidden ? 'hidden' : ''}`}>
      <button type="button" className="subject" name="accordion" onClick={changeIsOpen}>
        <p className="arrow">
          <img src={IcArrow} alt="Open / Close" className="svg" />
        </p>
        <p className="desc" dangerouslySetInnerHTML={{ __html: highlightedSubject}}/>
      </button>
      <div className="content">
        <p className="desc" dangerouslySetInnerHTML={{ __html: highlightedContent}}/>
      </div>
    </div>
  );
};

const Accordion = (props) => {
  const keyword = props.keyword;
  const data = props.data;
  return (
    <>
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          keyword={keyword}
          item={item}
        />
      ))}
    </>
  );
};


const Faq = () => {

  const [word, setWord] = useState('');
  const [keyword, setKeyword] = useState('');
  const [update, setUpdate] = useState(false);

  const changeKeyword = () => {
    setKeyword(word);
  }
  const changeWord = (e) => {
    setWord(e.target.value)
  }
  const removeWord = () => {
    setWord('');
    setUpdate(!update);
  }
  // 키보드 이벤트 처리 함수 (Enter 키를 감지)
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();  // 기본 엔터 동작(폼 제출 등)을 막음
      changeKeyword(word);
    }
  };

  useEffect(() => {
    changeKeyword();
  }, [update]);

  return (
    <>
      <section id="container" className="wrap">
        <div className="paragraph">
          <h1 className="subject"><strong>SKYTONE</strong></h1>
          <h2 className="title">FAQ</h2>
          <p className="desc">사용 시 흔히 겪는 문제와 궁금증을 모아 두었습니다.<br />필요한 내용이 있는지 찾아 보세요!</p>
        </div>
        <div className="search-field">
          <input type="text" name="faqKeyword" required onChange={changeWord} onKeyDown={handleKeyDown} value={word} />
          <button type="button" name="search" value="delete" onClick={removeWord}><i className="icon"><img src={IcClose} alt="CLOSE" className="svg" /></i></button>
          <button type="button" name="search" value="confirm" onClick={changeKeyword}>검색</button>
        </div>
        <Accordion data={faqList} keyword={keyword} />
      </section>
    </>
  );
};

export default Faq;
